<template>
  <div>
    <div class="head">
      <div class="headbar">
        <div class="container">
          <div class="head-lt">
            <a>欢迎回来到沃德珠宝！</a>
          </div>
          <div class="head-md webCSS">
            <marquee direction="left">
              温馨提示：ECO肉眼干净，EC1 90%肉眼干净，EC2肉眼不干净
              1、未到货品的“地点”一栏显示为”ind”，已到货品显示”HK”，预计3-7个工作日到香港，并不提供具体预计到货时间查询。
              2、实际到货后， 货品“地点”将变更为”HK”。
              3、下单即视为可以接受货品7个工作日之内到港。
              4、货品质量与香港现货库存一致。
            </marquee>
          </div>
        </div>
      </div>
      <div class="head-nav">
        <div class="header">
          <div class="header-lt">
            <div class="logo">
              <a href>
                <img src="/static/img/img/logo.png" />
              </a>
            </div>
          </div>
          <div class="header-ce">
                    <div class="nav">
                        <ul>
                           <li @click="goPage('Home')">首页</li>
                            <li @click="goPage('DiamondSearch')">GIA裸钻</li>
                            <li @click="goPage('MyCar')">我的购物车</li>
                            <li @click="goPage('MyOrder')">我的订单</li>
                            <li @click="goPage('Calculator', true)">计算器</li>
                            <li @click="goPage('FeedBack', true)">问题反馈</li>
                            <li @click="goPage('ChangePass')">修改密码</li>
                            <li @click="loginOut">注销登录</li>
                        </ul>
                    </div>
                </div>
        </div>
      </div>
    </div>
    <div class="war">
        <img src="/static/img/img/brs1.png" class="login-img" />
        <div class="container">
            <div class="login_gird">
                <fieldset class="fslogin webCSS">会员登录</fieldset>
                <hr class="mgtop webCSS" />
                <fieldset class="fslogin ">
                    <i class="userbg"></i>
                    <input type="text" id="username" name="username" v-model="database.username" class="btn-user" placeholder="请输入登录账号或者手机号码" />
                </fieldset>
                <fieldset class="fslogin">
                    <i class="pwdbg"></i>
                    <input type="password" id="pswd" name="pswd" class="btn-pwd" v-model="database.password" placeholder="请输入密码" />
                </fieldset>
                <fieldset class="fslogin btn_login">
                    <div  @click="onSubmit" class="btn-lg" >登录</div>
                </fieldset>
                <fieldset class="fslogin">
                    <a class="regnew " v-if="uid != 19"  @click="goRegister('StaffRegister')">还没有账号？立即注册</a>
                </fieldset>
            </div>
        </div>
    </div>
    <div class="board" style="display: none">
      <div class="board_title">
        <i class="fa fa-file-audio-o" aria-hidden="true"></i>公告栏
        <span>Notice Board</span>
        <a class="board_close"></a>
      </div>
      <p>
        温馨提示：ECO肉眼干净，EC1 90%肉眼干净，EC2肉眼不干净
        1、未到货品的“地点”一栏显示为”ind”，已到货品显示”HK”，预计3-7个工作日到香港，并不提供具体预计到货时间查询。
        2、实际到货后， 货品“地点”将变更为”HK”。
        3、下单即视为可以接受货品7个工作日之内到港。
        4、货品质量与香港现货库存一致。
      </p>
    </div>
  </div>
</template>
<script>
import Core from '@/until/core'
export default {
  name: 'StaffLogin',
  data () {
    return {
      options: {},
      database: {
        username: '',
        password: ''
      }
    }
  },
  computed: {
    uid () {
      return this.$route.params.Uid
    }
  },
  methods: {
    onSubmit () {
                const that = this
                if (!that.database.username || !that.database.password) {
                    return that.$store.commit('onChangeAppMessage', '账号或密码不能为空！')
                }
                let username = that.database.username
                let pre
                if (parseInt(this.uid) === 9) {
                    pre = 'YOUSHI'
                } else if (parseInt(this.uid) === 19) {
                    pre = 'JJL'
                }
                if (!/^1[3-9]{1}[0-9]{9}$/.test(username) && username.toUpperCase().indexOf(pre) === -1) {
                    username = pre + '@' + username
                }
                const param = Object.assign({username: username, password: that.database.password}, {share_id: that.$route.params.ShareId || '', user_id: parseInt(that.$route.params.Uid, 10) || 0})
                that.$store.commit('onChangeAppLoaderShow', '正在登录, 请稍候...')
                Core('Api/Staff/DiamondLogin', param).then(body => {
                    that.$store.commit('onChangeAppLoaderShow', false)
                    if (!body.data || body.data.error_code) {
                        return that.$store.commit('onChangeAppMessage', body.data.error_msg || '登录失败, 请稍候再试')
                    }
                    Core.onSetToken(that.$route.params.Uid, body.data.data.access_code, body.data.data.access_token, body.data.data.expires_time)
                    Core('Api/User/Detailed').then(body => {
                        if (body.data && !body.data.error_code && body.data.data) {
                            that.$store.commit('onChangeStaffData', body.data.data)
                        }
                    })
                    Core.goNext('Home', that.$route.params)
                })
            },
    goPage (name, bool) {
        const that = this
        if (bool) {
            return Core.goNext(name, that.$route.params)
        }
        Core.loginExist().then(res => {
            if (res) {
                return Core.goNext(name, that.$route.params)
            }
            Core.goNext('StaffLogin', that.$route.params)
        })
    },
    loginOut () {
                Core.onRemoveToken()
                Core.goNext('StaffLogin', this.$route.params, true)
            },
    goBack () {
      Core.goBack()
    },
    goRegister (name) {
      const that = this
      Core.goNext(name || 'Home', that.$route.params)
    }
  },
  mounted () {
    const that = this
    if (Core.hasToken()) {
      Core('Api/User/Detailed').then(body => {
        if (body.data && !body.data.error_code && body.data.data) {
          that.$store.commit('onChangeStaffData', body.data.data)
          that.$store.commit('onChangeAppLoaderShow', '自动登录中, 请稍候...')
          return setTimeout(() => {
            that.$store.commit('onChangeAppLoaderShow', false)
            Core.goNext('Home', that.$route.params)
          }, 800)
        }
      })
    }
  }
}
</script>
<style scoped>
@import "../../node_modules/swiper/dist/css/swiper.min.css";
@import "../../static/css/yellow.css";
@import "../../static/css/font-awesome.css";
.nav{ height: 90px; }
.header-ce{ width:1000px; }
.header-ce ul li{ float: left; line-height: 90px; width:100px; text-align: center;}
.Home-banner {
  width: 100%;
  height: 600px;
  overflow: hidden;
  background-color: #fff;
}
.btn-hk {
  color: #fff;
  padding: 8px 16px;
  line-height: 100px;
  background: #f268a3;
  border-radius: 2px;
  font-size: 13px;
}

.modelBox {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.65);
  overflow: hidden;
  z-index: 999;
}

.model {
  position: absolute;
  width: 1000px;
  height: 500px;
  margin: 0 auto;
  left: 0;
  right: 0;
  top: calc(50% - 350px);
  z-index: 9999;
  text-align: center;
  padding: 50px 0;
}

.closed {
  display: block;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  position: absolute;
  right: 150px;
  top: 120px;
  text-align: center;
  line-height: 22px;
  background: #e0b12f;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}

.timeer {
  text-align: center;
  position: absolute;
  bottom: 0;
  width: 100px;
  margin: auto;
  left: 0;
  right: 0;
  line-height: 40px;
  font-size: 14px;
  color: #ffeb3b;
  font-size: 30px;
  border-radius: 5px;
}
.login-main {
  padding: 0.4rem 0.26rem;
}
.login-info {
  width: 100%;
  height: 1rem;
  border-bottom: 1px solid #ebebeb;
  padding: 0 0.15rem;
  font-size: 0.3rem;
  line-height: 0.98rem;
}
.login-info-input {
  width: 100%;
  height: 100%;
  border: 0;
  background-color: transparent;
  outline: none;
}
.login-btn {
  width: 100%;
  height: 1rem;
  margin-top: 1rem;
  line-height: 1rem;
  text-align: center;
  font-size: 0.32rem;
  color: #fff;
  border-radius: 0.5rem;
  background-color: #ff410f;
}
</style>



// WEBPACK FOOTER //
// src/components/StaffLogin.vue